/** Import polyfills here * */
//import "./polyfill/Polyfill";

import App from "./modules/App";


(() => {
  App.init();
})();
